import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f75f126"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-appointed-practice-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Appoint new Practice"),
  /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Practices")
], -1))
const _hoisted_3 = { class: "body-main" }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "icon-hm" }
const _hoisted_6 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_7 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle mt-2 mr-1" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please search and select a branch", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mt-2" }),
  /*#__PURE__*/_createElementVNode("span", null, " Please be aware that an email notification will be sent to the Trust Coordinator of the relevant office location ")
], -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = {
  class: "checkbox-elmt",
  style: {"border":"none"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))
const _hoisted_18 = { class: "checkbox-text" }
const _hoisted_19 = {
  key: 0,
  style: {"color":"var(--ls-slate)"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mt-2 mr-1" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice ID", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice Name", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Branch address", -1))
const _hoisted_24 = {
  key: 3,
  class: "showMore mt-2 mb-1"
}
const _hoisted_25 = {
  key: 1,
  class: "error"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle mt-2 mr-1" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please select a branch", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "controls mt-4" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      halfScreen: "true",
      onClose: _cache[5] || (_cache[5] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["search-bar", _ctx.submitPressed && _ctx.searchText == '' ? 'error':''])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Search Practice ID or Practice name",
                maxLength: "75",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchText) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchText]
              ]),
              _createElementVNode("span", _hoisted_5, [
                (_ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : (_openBlock(), _createElementBlock("i", _hoisted_7))
              ])
            ], 2),
            _createElementVNode("button", {
              class: "btn btn-secondary sml ml-2",
              disabled: _ctx.isSearching || _ctx.searchText.length === 0,
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchPractice(_ctx.skip, 5, true)))
            }, "Search", 8, _hoisted_8)
          ]),
          (_ctx.submitPressed && _ctx.searchText == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : _createCommentVNode("", true),
          _hoisted_13,
          _createElementVNode("div", {
            class: _normalizeClass(["results", (_ctx.searchPressed && _ctx.submitPressed && this.practiceList.length > 0 && this.selectedPracticeList.length == 0) ? 'empty' : '' ])
          }, [
            (!_ctx.isSearching && _ctx.searchPressed && _ctx.practiceList.length == 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No results found "))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.practiceList, (p) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["checkbox-button", p.isSelectable ? '' : 'disabled'])
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        disabled: !p.isSelectable,
                        onClick: $event => (_ctx.updateSelected(p))
                      }, null, 8, _hoisted_15),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("span", _hoisted_18, [
                          (!p.isSelectable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("span", null, _toDisplayString(p.notSelectableCriteria?.description), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_21,
                          _createElementVNode("div", null, _toDisplayString(p.firmId), 1),
                          _hoisted_22,
                          _createElementVNode("div", null, _toDisplayString(p.practiceName), 1),
                          _hoisted_23,
                          _createElementVNode("div", null, _toDisplayString(p.address), 1)
                        ])
                      ])
                    ], 2)
                  ]))
                }), 256)),
            (_ctx.isSearching)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 2,
                  class: "loading-indicator ml-2",
                  showLoadingText: false
                }))
              : _createCommentVNode("", true),
            (_ctx.displayShowMoreButton && !_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (!_ctx.isSearching)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "link",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchPractice(_ctx.numResultsShowing, 5, false)))
                      }, "Show more"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.searchPressed && _ctx.submitPressed && this.practiceList.length > 0 && this.selectedPracticeList.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline",
            disabled: _ctx.submitting,
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Cancel ", 8, _hoisted_30),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: _ctx.submitting || _ctx.isSearching,
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.submitButtonPressed()), ["prevent","stop"]))
          }, " Appoint ", 8, _hoisted_31)
        ])
      ]),
      _: 1
    })
  ]))
}